import { useContext } from "react";
import { DictionaryContext, } from "./DictionaryProvider";
var useDictionaryContext = function () {
    return useContext(DictionaryContext);
};
export { useDictionaryContext };
